/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function getSupply (appId, categoryId, pageSize, pageCurrent) {
  if (categoryId === null) {
    categoryId = ''
  }
  return api({
    method: 'get',
    url: `/supply/list/${appId}?categoryId=${categoryId}&pageSize=${pageSize}&pageCurrent=${pageCurrent}`
  })
}

export function createSupply (appId, params) {
  return api({
    method: 'post',
    url: '/supply/' + appId,
    data: params
  })
}

export function updateSupply (appId, supplyId, params) {
  return api({
    method: 'put',
    url: '/supply/' + supplyId + '/' + appId,
    data: params
  })
}

export function deleteSupply (supplyId, appId) {
  return api({
    method: 'delete',
    url: '/supply/' + supplyId + '/' + appId
  })
}
